var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgHtml = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 40.51 50"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "html_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Rectangle 513",
  fill: "none",
  d: "M0 0h40.51v50H0z"
})))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  "data-name": "Artwork 3"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 1266",
  clipPath: "url(#html_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 3185",
  d: "M1.327 0A1.327 1.327 0 0 0 0 1.327v47.332a1.327 1.327 0 0 0 1.327 1.327h37.856a1.327 1.327 0 0 0 1.327-1.327V16.251a3.743 3.743 0 0 0-.948-2.274L26.58.948A3.743 3.743 0 0 0 24.306 0Z",
  fill: "gray"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 3186",
  d: "M2.464.9a1.327 1.327 0 0 0-1.327 1.327v45.958a1.327 1.327 0 0 0 1.327 1.327h36.245a1.327 1.327 0 0 0 1.328-1.327V16.441a3.743 3.743 0 0 0-.948-2.274L26.77 1.848A3.743 3.743 0 0 0 24.495.9Z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 3187",
  d: "M26.533 4.454v6.728a2.559 2.559 0 0 0 2.559 2.559h7.012Z",
  fill: "#eaecef"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 3188",
  d: "m26.012 12.746-.616-11.04-.948 12.6a1.327 1.327 0 0 0 1.374 1.327h12.177l-10.613-1.561a1.327 1.327 0 0 1-1.327-1.327",
  fill: "#e6e7e8"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 3189",
  d: "M40.037 35.914a1.184 1.184 0 0 1-1.184 1.184H2.321a1.184 1.184 0 0 1-1.184-1.184v-13.6a1.184 1.184 0 0 1 1.184-1.183h36.53a1.184 1.184 0 0 1 1.186 1.184Z",
  fill: "#971016"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 3190",
  d: "M40.037 36.625a1.184 1.184 0 0 1-1.185 1.137H2.321a1.184 1.184 0 0 1-1.184-1.184v-13.6a1.184 1.184 0 0 1 1.184-1.183h36.53a1.184 1.184 0 0 1 1.186 1.184Z",
  fill: "#d55a67"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 3191",
  d: "M3.885 34.066v-8.955h1.279v3.79h4.221v-3.79h1.279v8.955H9.385v-4.264H5.164v4.264Z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 3192",
  d: "M15.066 34.066v-8.007h-3.174v-.948h7.628v.948h-3.174v8.007Z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 3193",
  d: "M20.752 34.066v-8.955h1.753l2.464 6.917 2.558-6.917h1.564v8.955h-1.185v-7.3l-2.464 6.681h-1.231l-2.369-6.678v7.3Z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 3194",
  d: "M31.413 34.066v-8.955h1.232v8.007h4.027v.948Z",
  fill: "#fff"
})))));
export default SvgHtml;